import { action, observable } from 'mobx'
import Api from '@api/xiao_xiong/notice'
import { isObj } from '@hlj/hlj-utils'
import { notify_type } from './config'
import { getMerchantInfo, HLJ_STATISTIC } from '@util'
import { message } from 'hljd'

/**
 * 这个是主账号的通知，跟子账号有所区别
 * 暂时先搬了一份过来给司仪团队账号用
 */
class Store {
  /**
   * 分页信息
   */
  @observable
  pagination = {
    //分页信息
    showQuickJumper: true,
    showTotal: total => `共 ${total} 条`,
    showSizeChanger: true,
    current: 1,
    pageSize: 20,
    total: 0
  }

  @action
  paginationChange = (current, pageSize) => {
    this.pagination.current = current
    this.pagination.pageSize = pageSize
    this.getNoticeList(current)
  }

  /**
   *
   * 菜单类别
   */
  @observable
  selectTab = notify_type
    .filter(item => !item.hidden)
    .find(item => item.isDefault).id

  @action
  changeSelectTab = type => () => {
    this.selectTab = type // 发券助手  type === 19
    this.readStatus = ''
    this.getNoticeList(1)
  }

  /**
   * 全部 or 未读 列表
   */
  @observable readStatus = '' // 默认为全部''  '0'为未读 2
  @action
  onChangeStatus = e => {
    this.readStatus = e.target.value
    this.getNoticeList(1)
  }

  /**
   * 获取通知列表
   */
  @observable noticeList = []
  @observable isLoading = false

  getNoticeList = async (page = this.pagination.current) => {
    let params = {
      notify_type: this.selectTab,
      per_page: this.pagination.pageSize,
      status: this.readStatus,
      page
    }
    this.isLoading = true
    const {
      data: { list, total_count = 0 }
    } = await Api.getNoticeListApi(params)
    this.pagination.total = +total_count
    this.pagination.current = page
    this.noticeList = list || []
    this.isLoading = false
  }

  /**
   * 获取未读条数
   */
  @observable unreadObj = {}
  @action
  getUnread = async () => {
    const { data } = await Api.getUnreadApi()
    this.unreadObj = data || {}
  }

  /**
   * 获取通知名称
   */
  getNoticeName = notify_type => {
    let style = notify_type == '10' ? '17' : notify_type
    let obj = { name: '', style: `notice_${style}` }
    switch (String(notify_type)) {
      case '2':
        obj.name = '订单消息'
        break
      case '3':
        obj.name = '活动助手'
        break
      case '4':
        obj.name = '预约消息'
        break
      case '6':
        obj.name = '营收消息'
        break
      case '16':
        obj.name = '评价助手'
        break
      case '17':
      case '10':
        obj.name = '互动消息'
        break
      case '19':
        obj.name = '发券助手'
        break
      default:
        obj.name = '系统消息'
        obj.style = 'notice_others'
    }
    return obj
  }

  /**
   * 通知列表数据转换相关函数
   */
  getMessage = item => {
    const { notify_type, action, content, extra_objects = {} } = item
    let cont = ''
    let ct = ''
    let grade = ''
    let merInfo
    let type = String(notify_type)
    switch (type) {
      //1=>"社区通知",2=>"订单小精灵",3=>"婚礼纪活动",4=>"预约小助手",5=>"评论",6=>"收入小管家",7=>"审核小秘书"
      case '9':
        if (action != 'merchant_notify_text') {
          let _json = JSON.parse(content || null)
          if (action == 'merchant_notify_feature') {
            if (_json.target_type == '100') {
              merInfo = getMerchantInfo()
              grade = merInfo.grade.grade_level
            }
          }
        }
        break
    }
    if (action == 'audit_success' || action == 'audit_fail') {
      ct = extra_objects.set_meal.commodity_type
    }
    if (content) {
      cont = content
    }
    return { cont, ct, grade }
  }

  goto = (item, messageObj, link, isSelf) => () => {
    let _entity = item.entity
    let _id = item.entity_id
    let _type = String(item.action)
    this.readNotice(item)

    if (_entity == 'MerchantNotification') {
      HLJ_STATISTIC({
        event_type: 'element_hit',
        data_type: 'Merchant_Notepush',
        data_id: _id,
        page_name: '消息列表/首页'
      })
    }

    const checkCommentActions = [
      'proof_from_user',
      'appeal_success_to_merchant',
      'appeal_fail_to_merchant',
      'order_comment_review_pass'
    ]
    if (checkCommentActions.includes(_type)) {
      this.checkComment(_id, () => (window.location.href = link))
    }
    // 当前商家的消息才跳转
    if (link && isSelf) {
      if (
        _type == 'order_comment_merchant' ||
        _type == 'order_comment_review_reply_merchant'
      ) {
        let _realId = item.body == '回复了你' ? item.parent_entity_id : _id
        this.checkComment(_realId, () => window.open(link))
      } else {
        window.location.href = link
      }
    }
  }

  @action
  readNotice = async param => {
    let params
    let unreadNum = this.unreadObj[this.selectTab]
      ? Number(this.unreadObj[this.selectTab])
      : 0
    if (isObj(param) && param.id) {
      if (param.status == '2') {
        return
      }
      params = { id: param.id }
    } else {
      if (unreadNum == 0) {
        return
      }
      params = { notify_type: this.selectTab }
    }
    const { success } = await Api.readNoticeApi(params)
    if (success) {
      this.getUnread()
      this.getNoticeList()
    }
  }

  checkComment = async (_realId, redirect) => {
    const { data } = await Api.checkCommentApi({ id: _realId })
    let response = data || {}
    if (response.res == 1) {
      message.warning('该评价已经删除~')
    } else {
      redirect()
    }
  }
}

export default Store
